<template>
  <div v-cloak class="fixed-head-puppet">
    <div class="fixed-head">
      <div class="hello">
        <div class="heard flex f-between">
          <div>
            <div class="imgs">
              <img src="../img/logo.png" alt="" @click="toPage" />
            </div>
            <div class="title">
              <div
                @click="toggle(list.path)"
                v-for="(list, indexs) in titles"
                :key="indexs"
                :class="list.path == paths ? 'actives' : 'title-c'"
              >
                {{ list.name }}
              </div>
            </div>
            <!-- <el-input class="search" @change="search" placeholder="搜索点什么" suffix-icon="el-icon-search" v-model="input2"></el-input>
			<span class="se">搜索</span> -->
          </div>
          <div class="loginss">
            <span class="usernames" v-if="logintype" @click="login">{{
              names == "undefined"
                ? "你好，会员用户"
                : names == "登录"
                ? names
                : "您好，" + names
            }}</span>
            <el-divider v-if="logintype" direction="vertical"></el-divider>
            <span v-if="loginstatus" class="quits" @click="quit">退出登录</span>
            <span v-if="!loginstatus" @click="register">注册</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quitlogin, getuser } from "../api.js";
// import store from "../store/index.js";
export default {
  name: "Heard",
  props: {
    msg: String,
  },
  data() {
    return {
      titles: [
        { name: "首页", path: "/", index: "0" },
        { name: "方舟资讯", path: "/Resource", index: "1" },
        { name: "活动沙龙", path: "/Practice", index: "3" },
        //{ name: "关于方舟", path: "/About", index: "4" },
        { name: "课程中心", path: "/Learn", index: "2" },
        { name: "专家专栏", path: "/Expert", index: "8" },
        { name: "解决方案", path: "/Datum", index: "5" },
        { name: "问卷调研", path: "/Survey", index: "7" },
        { name: "会员中心", path: "/User", index: "6" },
      ],
      input2: "",
      paths: "/",
      names: "", //用户姓名
      logintype: "", //shifou登录
      loginstatus: "", //是否登录
    };
  },
  created() {
    let token = localStorage.getItem("AccessToken") || "";

    // token ? (this.loginstatus = true) : (this.loginstatus = false);
    if (token) {
      getuser({ token: token }).then((res) => {
        this.names = res.data.Data.Nickname;
      });
      this.loginstatus = true;
      this.logintype = true;
    } else {
      this.loginstatus = false;
      this.logintype = true;
      this.names = "登录";
    }
  },
  filters: {
    sn(e) {
      if (e) {
        return e.length > 4 ? e.slice(0, 4) + "..." : e;
      } else {
        return e;
      }
    },
  },

  watch: {
    $route(to) {
      this.paths = to.path;
      if (to.path == "/Login" || to.path == "/Register" || to.path == "/Find") {
        let token = localStorage.getItem("AccessToken") || "";

        if (token) {
          this.loginstatus = true;
          this.logintype = true;
          getuser({ token: token }).then((res) => {
            this.names = res.data.Data.Nickname;
          });
        } else {
          this.loginstatus = false;
          this.logintype = true;
          this.names = "登录";
        }
      } else {
        let token = localStorage.getItem("AccessToken");

        if (token) {
          this.loginstatus = true;
          this.logintype = true;
          getuser({ token: token }).then((res) => {
            this.names = res.data.Data.Nickname;
          });
        } else {
          this.loginstatus = false;
          this.logintype = true;
          this.names = "登录";
        }
      }
    },
  },

  methods: {
    toPage() {
      this.$router.push({ path: "/" });
    },
    toggle(path) {
      this.paths = path;
      this.$router.push(`${path}`);
    },
    login() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$router.push("/Login");
      }else{
        this.$router.push("/User");
      }
    },
    register() {
      this.$router.push("/Register");
    },

    quit() {
      let token = localStorage.getItem("AccessToken");
      let datas = {
        Source: "web",
        Token: token,
      };

      this.$confirm("您确定退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        quitlogin(datas).then((res) => {
          if (res.data.Code == 0) {
            localStorage.removeItem("AccessToken");
            localStorage.removeItem("RefreshToken");
            localStorage.removeItem("username");
            localStorage.removeItem("AccessTokenTime");
            localStorage.removeItem("RefreshTokenTime");
            localStorage.removeItem("videostatus");
            localStorage.removeItem("ppttoken");
            this.names = "登录";
            this.loginstatus = false;
            this.$message({
              message: "退出登录成功",
              type: "success",
            });
            setTimeout(() => {
              this.$router.go(0);
            }, 500);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss">
.fixed-head-puppet {
  height: 88px;
  width: 100%;
}
.fixed-head {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 300;
  background: #fff;
}
.hello {
  min-width: 1200px;
  height: 90px;
  line-height: 88px;
  box-sizing: border-box;
}
.hello .heard {
  width: 1200px;
  margin: 0 auto;
  overflow: auto;
  box-sizing: border-box;
}
.hello .heard .imgs {
  width: 140px;
  height: 100%;
  float: left;
  display: flex;
  align-items: center;
  margin-right: 50px;
}
.hello .heard .imgs img {
  width: 100%;
  // height:100%;
  line-height: 88px;
}
.hello .title {
  float: left;
  margin-right: 40px;
}
.hello .title-c {
  // width:64px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-right: 40px;
  cursor: pointer;
  float: left;
}
.actives {
  font-size: 16px;
  border-bottom: 3px solid #234775;
  font-weight: bold;
  color: #234775;
  margin-right: 40px;
  cursor: pointer;
  float: left;
}
.hello .search {
  width: 253px;
  height: 32px;
  border-radius: 16px;
  float: left;
}
.hello .el-input__inner {
  border-radius: 16px;
}
.loginss {
  display: inline;
  // position: absolute;
  right: 0;
  margin-left: 15px;

  span {
    // font-weight: 600;
    font-size: 14px;
    cursor: pointer;
  }
}
.se {
  display: inline-block;
  margin-left: 10px;
  font-size: 14px;
  cursor: pointer;
  opacity: 0.9;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
}
</style>
